export const subusers = {
  title: "Sub-Users",
  subtitle: "Create and manage sub-users with access to your agents",
  newSubUser: "New Sub-User",
  noSubUsers: "No sub-users found",
  edit: "Edit",
  delete: "Delete",
  name: "Name",
  email: "Email",
  password: "Password",
  phone: "Phone",
  create: "Create Sub-User",
  table: {
    title: "Name",
    email: "Email",
    password: "Password",
    phone: "Phone",
    actions: "Actions",
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
  },
  update: "Update",
  invalidEmail: "Invalid email",
  invalidEmailDescription: "Please enter a valid email",
};
